import { forwardRef, memo } from "react"
import { useSectionPad } from "components/layout/section"

interface TableListProps {
    children: React.ReactNode
    className?: string
    width?: "fit" | "full"
    highlightDragAndDrop?: boolean
}

const TableList = forwardRef<HTMLDivElement, TableListProps>(({ children, className, width = "full", highlightDragAndDrop = false }, ref) => {
    const padX = useSectionPad()
    const flushMobile = !padX
    return (
        <div className={`w-full max-w-full overflow-x-auto ${className ?? ""}`}>
            <div className={`table border border-gray-200 ${flushMobile ? "rounded-none lg:rounded-lg max-lg:border-x-0" : "rounded-lg"} ${highlightDragAndDrop ? `bg-orange-100` : `bg-white`} ${width === "full" ? "w-full min-w-full" : "w-fit"}`} ref={ref}>
                {children}
            </div>
        </div>
    )
})

TableList.displayName = 'TableList'

export default memo(TableList)
